"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTokenModel = void 0;
const UserModel_1 = require("../Model/UserModel");
class AbstractTokenModel {
    constructor(data) {
        this.defaultPublicKey = process.env.SKELLO_AUTH_PUBLIC_KEY;
        this.token = data.token;
        this.refreshToken = data.refreshToken;
        if (data.token) {
            this.tokenData = this.parseToken(this.token);
        }
        if (data.refreshToken) {
            this.refreshTokenData = this.parseToken(this.refreshToken);
        }
    }
    get exp() {
        return this.tokenData?.exp;
    }
    get refreshExp() {
        return this.refreshTokenData?.exp;
    }
    get expirationTimeAsMilliseconds() {
        return this.exp * 1000;
    }
    get user() {
        return UserModel_1.UserModel.fromJSON({ ...this.tokenData.data });
    }
    get userId() {
        return this.tokenData.data.id + '';
    }
    refreshTokenIsExpired() {
        if (!this.refreshExp) {
            return true;
        }
        return this.refreshExp * 1000 < Date.now();
    }
    tokenIsExpired() {
        if (!this.exp) {
            return true;
        }
        // We add 30 secondes to expiration to be sure that we send a valid token when network is slow
        return this.expirationTimeAsMilliseconds < Date.now() + 30000;
    }
}
exports.AbstractTokenModel = AbstractTokenModel;
//# sourceMappingURL=AbstractTokenModel.js.map